import './faq-section.scss';
import autoComplete from 'pixabay-javascript-autocomplete';
import { getOffset, smoothScrollTo } from '../../js/helper';
import axios from 'axios';

class FaqSection {
    constructor (element) {
        this.$faqSection = element;
        this.$faqThemes = this.$faqSection.querySelector('[data-faq-section="themes"]');
        this.$faqQA = this.$faqSection.querySelector('[data-faq-section="qa"]');

        this.$$themes = this.$faqThemes.querySelectorAll('[data-faq-section-theme-id]');
        this.$$categories = this.$faqThemes.querySelectorAll('[ data-faq-section-category]');
        this.$allCategories = this.$faqThemes.querySelector('[data-faq-section-category-all]');

        this.$input = this.$faqSection.querySelector('[data-faq-section="autocomplete"]');
        this.$form = this.$faqSection.querySelector('[data-faq-section="form"]');
        this.url = this.$form.getAttribute('action');
        this.$deleteInputButton = this.$faqSection.querySelector('[data-faq-section-delete-input]');
        this.autocompleteField = null;

        this.$faqCategorySwitch = this.$faqSection.querySelector('[data-faq-section-category-switch]');
        this.$showMoreInput = this.$faqQA.querySelector('[data-faq-section-show-more]');

        this.activeTheme = this.$faqSection.querySelector('.is--active').getAttribute('data-faq-section-theme-id');
        this.allThemesActive = false;
        this.votingRunning = false;

        this.faqData = [];
    }

    initialize () {
        this.setEvents();
        this.initAutoComplete();
    }

    setEvents () {
        this.$$themes.forEach((theme) => {
            theme.addEventListener('click', () => {
                const id = theme.getAttribute('data-faq-section-theme-id');

                if (id !== this.activeTheme) {
                    this.setTheme(theme);
                    this.setQA(theme, id);
                    this.activeTheme = id;
                }
            });
        });

        this.$$categories.forEach(($category) => {
            $category.addEventListener('change', () => {
                if ($category.checked) {
                    const $lastActive = this.$faqThemes.querySelector('[data-faq-section-category]:checked:not([id="' + $category.getAttribute('id') + '"])');

                    if ($lastActive) {
                        $lastActive.checked = false;
                    }
                    this.scrollToEntry(this.$faqQA.querySelectorAll('[data-faq-section-theme-id].is--active')[0]);
                }
            });
        });

        if (this.$allCategories) {
            this.$allCategories.addEventListener('click', () => {
                this.setQA(null, null, null);
                this.setTheme(this.$allCategories);
            });
        }

        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
        });

        this.$input.addEventListener('focus', () => {
            if (this.$input.value !== '') {
                const value = this.$input.value;
                this.$input.value = '';
                this.$input.value = value;
            }
        });

        this.$input.addEventListener('input', () => {
            if (this.$input.value !== '') {
                this.$deleteInputButton.classList.add('is--visible');
            } else {
                this.$deleteInputButton.classList.remove('is--visible');
            }
        });

        this.$deleteInputButton.addEventListener('click', () => {
            this.$input.value = '';
            this.$deleteInputButton.classList.remove('is--visible');
        });
    }

    setTheme (theme) {
        if (this.activeTheme !== '') {
            const $$activeThemes = this.$faqThemes.querySelectorAll('.is--active');

            $$activeThemes.forEach((active) => {
                active.classList.remove('is--active');
            });
        }

        theme.classList.add('is--active');
        const $categoryInput = theme.closest('.faq-section__category').firstElementChild;

        if ($categoryInput) {
            $categoryInput.checked = true;
        }

        if (theme.getAttribute('data-faq-section-theme-id')) {
            this.$faqCategorySwitch.innerText = theme.firstElementChild.innerText;
        }

        if (theme.getAttribute('data-faq-section-theme-all')) {
            this.$faqCategorySwitch.innerText = theme.getAttribute('data-faq-section-theme-all');
        }

        if (theme.getAttribute('data-faq-section-category-all')) {
            this.$faqCategorySwitch.innerText = theme.getAttribute('data-faq-section-category-all');
            const $activeCategory = this.$faqThemes.querySelector('[data-faq-section-category]:checked');

            if ($activeCategory) {
                $activeCategory.checked = false;
                this.$faqThemes.querySelectorAll('[data-faq-section-category]');
            }
        }

        if (window.innerWidth < 1024) {
            this.$faqCategorySwitch.previousElementSibling.checked = false;
        }
    }

    setQA (theme, id, $list) {
        if (theme && id) {
            if (this.activeTheme !== '') {
                const $$activeQAs = this.$faqQA.querySelectorAll('[data-faq-section-theme-id].is--active');

                if (this.$showMoreInput) {
                    this.$showMoreInput.checked = true;
                }

                $$activeQAs.forEach((QA) => {
                    QA.classList.add('is--hidden');
                    setTimeout(() => {
                        QA.classList.remove('is--active');
                        QA.classList.remove('is--hidden');
                    }, 250);
                });
            }

            const $qa = this.$faqQA.querySelector('[data-faq-section-theme-id="' + id + '"]');
            setTimeout(() => {
                $qa.classList.add('is--active');
                this.scrollToEntry($qa);
            }, 250);
        } else {
            if ($list) {
                const $$activeQAs = this.$faqQA.querySelectorAll('[data-faq-section-theme-id].is--active');

                if (this.$showMoreInput) {
                    this.$showMoreInput.checked = true;
                }

                $$activeQAs.forEach((QA) => {
                    QA.classList.add('is--hidden');

                    setTimeout(() => {
                        QA.classList.remove('is--active');
                        QA.classList.remove('is--hidden');
                    }, 250);
                });

                setTimeout(() => {
                    $list.querySelectorAll('[data-faq-section-theme-id]').forEach((theme) => {
                        const id = theme.getAttribute('data-faq-section-theme-id');
                        const $qa = this.$faqQA.querySelector('[data-faq-section-theme-id="' + id + '"]');

                        if ($qa) {
                            $qa.classList.add('is--active');
                            this.scrollToEntry($qa);
                        }
                    });
                }, 250);

                this.activeTheme = null;
            } else {
                const $$QAs = this.$faqQA.querySelectorAll('[data-faq-section-theme-id]');
                if (this.$showMoreInput) {
                    this.$showMoreInput.checked = false;
                }

                $$QAs.forEach((qa, index) => {
                    qa.classList.add('is--active');

                    if (index === 0) {
                        this.scrollToEntry(qa);
                    }
                });
            }
        }
    }

    initAutoComplete () {
        this.autocompleteField = new autoComplete({ // eslint-disable-line
            selector: this.$input,
            renderItem: (item, search) => {
                search = search.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
                const re = new RegExp('(' + search + ')', 'gi');
                return '<div class="autocomplete-suggestion" data-label-id="' + item.id + '"><p>' + item.label.replace(re, '<strong>$1</strong>') + '</p></div>';
            },
            source: (term, suggest) => {
                axios({
                    method: 'POST',
                    url: this.url,
                    data: new FormData(this.$form)
                }).then((result) => {
                    suggest(result.data);
                });
            },
            minChars: 2,
            onSelect: (event, term, item) => {
                const $item = item;
                const entryId = $item.getAttribute('data-label-id');
                const $entry = document.querySelector('[for="accordion-element-' + entryId + '"]');

                if ($entry) {
                    const themeId = $entry.closest('[data-faq-section-theme-id]').getAttribute('data-faq-section-theme-id');
                    const $theme = document.querySelector('[data-faq-section-theme-id="' + themeId + '"]');

                    if ($theme) {
                        $theme.click();
                        if (!$entry.classList.contains('is--active')) {
                            setTimeout(() => {
                                $entry.click();
                            }, 1000);
                        }

                        setTimeout(() => {
                            this.scrollToEntry($entry);
                        }, 250);
                    }
                }
            }
        });
    }

    scrollToEntry ($entry) {
        const headerHeight = document.querySelector('[data-header="root"]')?.clientHeight || 0;
        let faqNavigationHeight = 20;

        if (window.innerWidth < 1024) {
            const searchContainer = document.querySelector('.faq-section__search-container')?.clientHeight || 0;
            faqNavigationHeight = document.querySelector('.faq-section__navigation')?.clientHeight || 0;
            faqNavigationHeight += searchContainer + 40;
        }
        const anchorMovement = getOffset($entry).top - headerHeight - faqNavigationHeight;
        smoothScrollTo(0, anchorMovement, 500);
    }
}

export { FaqSection };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $faqSection = $context.querySelector('[data-faq-section="root"]');

        if ($faqSection) {
            const $FaqSection = new FaqSection($faqSection);
            $FaqSection.initialize();
        }
    }
});
